<template>
  <el-tabs v-model="tabName" type="border-card" @tab-click="onTabClick">
    <el-tab-pane label="Circulares"
      ><DocumentsListOurCompany ref="circular" tabFrom="cir"
    /></el-tab-pane>
    <el-tab-pane label="Politicas y Procesos"
      ><DocumentsListOurCompany ref="docs" tabFrom="pol"
    /></el-tab-pane>
    <el-tab-pane label="Comunicaciones"
      ><DocumentsListOurComunication ref="comunicaciones" tabFrom="com"
    /></el-tab-pane>
  </el-tabs>
</template>

<script>
import DocumentsListOurCompany from "@/views/apps/our_company/documents/DocumentsListOurCompany.vue";
import DocumentsListOurComunication from "@/views/apps/our_company/documents/DocumentsListComunications.vue";
export default {
  name: "OurCompanyDocuments",
  components: {
    DocumentsListOurCompany,
    DocumentsListOurComunication
  },
  data() {
    return {
      tabName: ""
    };
  },
  methods: {
    onTabClick() {
      switch (this.tabName) {
        case "0": {
          this.$refs.circular.getTableData();
          break;
        }
        case "1": {
          this.$refs.docs.getTableData();
          break;
        }
        case "2": {
          this.$refs.comunicaciones.getTableData();
          break;
        }
      }
    }
  }
};
</script>

<style></style>
